import type { PatientApplyProfileData } from '@modules/patientApplyProfile/helpers/PatientApplyProfileData'
import type { PatientTrialApplySurveyAttribute } from './types'

/**
 * Fetch the value for the attribute in the given patient profile
 * @property {PatientTrialApplySurveyAttribute} attribute - Attribute to check for
 * @property {PatientApplyProfileData} patientProfileData - Patient profile to search in
 * @returns {string[] | null} Attribute value, or null if not found
 */
export function getAttributeDataFromPatientProfileData({
  attribute,
  patientProfileData,
}: {
  attribute: PatientTrialApplySurveyAttribute
  patientProfileData: PatientApplyProfileData
}) {
  return patientProfileData
    .filter((d) => d.conceptName === attribute)
    .map((d) => d.conceptValue)
}
